<template>
	<div class="head" :class="$store.state.mode"> 
		<!-- header -->
		<div class="navbar" :class="($store.state.mode === 'dark') ? 'dark-header-active' : 'false'">
			<a class="nav-icon" v-on:click="sideBarActive" :class="{'isActive': $store.state.isSidebarActive}">
				<span></span>
				<span></span>
				<span></span>
			</a>
			<div class="title">
				<img src="@/assets/logo/icon.png" class="img" alt="Islamic an audio and podcast">
			</div>
			<a class="search-icon">
				<i v-on:click="$router.push('/search')" class="el-icon-search search"></i> 
			</a>
		</div>
		<!-- sidebar -->
		<div class="sidebar" :class="[{'isActive': $store.state.isSidebarActive}, ($store.state.mode === 'dark') ? 'dark-sidebar' : 'false']">
			<div v-ripple v-on:click="$router.push('/profileuser')" class="item" :class="($store.state.mode === 'dark') ? 'dark-item-active' : 'false'">
				<i class="material-icons">account_circle</i>
				<div class="title">My Profile</div>
			</div>
			<div v-ripple v-on:click="$router.push('/settings')" class="item" :class="($store.state.mode === 'dark') ? 'dark-item-active' : 'false'">
				<i class="material-icons">settings</i>
				<div class="title">Settings</div>
			</div>
			<div v-ripple v-on:click="logout" class="item" :class="($store.state.mode === 'dark') ? 'dark-item-active' : 'false'">
				<i class="material-icons">logout</i>
				<div class="title">Logout</div>
			</div>
		</div>
	</div>
</template>

<script>
import firebase from 'firebase'
export default {
	methods: {
		sideBarActive: function() {
			this.$store.commit('setSidebarActive',!this.$store.state.isSidebarActive)
			this.$emit('sideBarActive', this.isSidebarActive)
		},
		logout: function() {
			let _this = this
			firebase.auth().signOut().then(function() {
				_this.$store.commit('setCurrentUser',null)
				setTimeout(() => _this.isHidden = false, 1000);
				_this.$router.push('/landing')
			}).catch(function(error) {
				_this.console.log(error)
			});
		},
	},
};
</script>

<style lang="scss">
.navbar.dark-header-active .nav-icon {
	span {
		background-color: white;
	}
}
.navbar.dark-header-active {
	background-image: linear-gradient(rgb(0,0,0), transparent);
}
.navbar.false {
	background-image: linear-gradient(rgb(255,255,255), rgb(255,255,255));
	box-shadow: 0 1px 10px rgba(0,0,0, .03);
}
.navbar {
	z-index: 99;
	position: fixed;
	width: 100%;
	height: 4rem;
	padding: 0 1.5rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	backdrop-filter: blur(1px);
	.title {
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			width: 25px;
			filter: saturate(7);
		}
	}
}
.nav-icon {
	width: 20px;
	height: 12px;
	-webkit-transform: rotate(0deg);
	transform: rotate(0deg);
	-webkit-transition: 0.25s ease-in-out;
	transition: 0.25s ease-in-out;
	span {
		display: block;
		position: absolute;
		height: 2px;
		width: 100%;
		background: #000;
		border-radius: 6px;
		opacity: 1;
		transform: rotate(0deg);
		transition: 0.5s ease-in-out;
	}
	span:nth-child(1) {
		width: 80%;
		top: 0px;
	}
	span:nth-child(2) {
		top: 5px;
	}
	span:nth-child(3) {
		top: 10px;
		width: 65%;
	}
	&.isActive span:nth-child(1) {
		top: 5px;
		width: 100%;
		transform: rotate(135deg);
	}
	&.isActive span:nth-child(2) {
		opacity: 0;
		width: 100%;
		left: -60px;
	}
	&.isActive span:nth-child(3) {
		top: 5px;
		width: 100%;
		transform: rotate(-135deg);
	}
}
.search-icon {
	top: 0.2rem;
	position: relative;
	.search {
		font-size: 22px;
	}
}
.sidebar.dark-sidebar {
	background-color: rgba(27, 123, 70, .1);	
}
.sidebar {
	display: flex;
	flex-flow: column;
	justify-content: space-evenly;
	align-items: center;
	background-color: rgba(27, 123, 70, 0.015);
	padding: .5rem;
	left: 1rem;
	margin-top: 5rem;
	transition: 0.45s;
	border-radius: 14px;
	position: fixed;
	will-change: transform;
	overflow: hidden;
	transform: translateX(-200%);
	scroll-behavior: all;
	&.isActive {
		transform: translateX(0);
	}
	.item.dark-item-active {
		background-color: rgba(27, 123, 70, .1);
	}
	.item {
		display: flex;
		flex-flow: column;
		justify-content: space-evenly;
		align-items: center;
		width: 120px;
		height: 100px;
		padding: 1rem;
		margin: .5rem;
		border-radius: 14px;
		transition: .5s;
		background-color: rgba(27, 123, 70, 0.050);
		&:active {
			transform: scale(.9);
		}
		.title {
			font-size: 12px;
		}
	}
}
</style>